import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  CONFIRM_USER,
  CONFIRM_USER_SUCCESS,
  DELETE_PROFILE,
  UPDATE_PROFILE,
  UPDATE_AUTHSTATE,
  UPDATE_AUTHDATA,
  USER_PRIVILEGES_GET,
  USER_PRIVILEGES_GET_SUCCESS,
  USER_PRIVILEGES_GET_ERROR,
  SET_AMPLIFY_CONFIG_STATUS,
  WEBPUSH_PERMISSION_START,
  WEBPUSH_PERMISSION_SUCCESS,
  WEBPUSH_PERMISSION_ERROR,
  APP_PUSH_TOKEN_SUCCESS
} from "../actions";

export const loginUser = (user, history) => ({
  type: LOGIN_USER,
  payload: { user, history }
});
export const loginUserSuccess = user => ({
  type: LOGIN_USER_SUCCESS,
  payload: user
});

export const registerUser = (user, history) => ({
  type: REGISTER_USER,
  payload: { user, history }
});
export const registerUserSuccess = user => ({
  type: REGISTER_USER_SUCCESS,
  payload: user
});

export const confirmUser = (user, history) => ({
  type: CONFIRM_USER,
  payload: { user, history }
});
export const confirmUserSuccess = user => ({
  type: CONFIRM_USER_SUCCESS,
  payload: user
});

export const logoutUser = history => ({
  type: LOGOUT_USER,
  payload: { history }
});

export const deleteProfile = () => ({
  type: DELETE_PROFILE,
  payload: {}
});

export const updateProfile = profile => ({
  type: UPDATE_PROFILE,
  payload: profile
});

export const updateAuthState = authState => ({
  type: UPDATE_AUTHSTATE,
  payload: authState
});

export const updateAuthData = authData => ({
  type: UPDATE_AUTHDATA,
  payload: authData
});

export const getUserPrivileges = (appId, hotelId) => ({
  type: USER_PRIVILEGES_GET,
  payload: { appId, hotelId }
});

export const getUserPrivilegesSuccess = userPrivileges => ({
  type: USER_PRIVILEGES_GET_SUCCESS,
  payload: userPrivileges
});

export const getUserPrivilegesError = error => ({
  type: USER_PRIVILEGES_GET_ERROR,
  payload: error
});

export const setAmplifyConfigStatus = status => ({
  type: SET_AMPLIFY_CONFIG_STATUS,
  payload: status
});

export const webPushPermissionStart = (hotelConfig, userPrivileges) => ({
  type: WEBPUSH_PERMISSION_START,
  payload: { hotelConfig, userPrivileges }
});

export const webPushPermissionSuccess = () => ({
  type: WEBPUSH_PERMISSION_SUCCESS,
  payload: {}
});
export const webPushPermissionError = error => ({
  type: WEBPUSH_PERMISSION_ERROR,
  payload: error
});

export const appPushTokenSuccess = token => ({
  type: APP_PUSH_TOKEN_SUCCESS,
  payload: token
});
